import api from '@/com/system/api'

class DataServices {

  async getPdfList (target = '/') {
    const response = await api.get(`/v1/pdflist${target}`)
    return response
  }

  async triggerPull () {
    await api.get(`/v1/test`)
  }

  async jobCheck() {
    let riz = await api.get('/v1/running')
    return riz.data
  }

  async processsingle (key) {
    let data = { pdfKey: key, outputBucket: 'claude-csv'}
    let riz = await api.post('/v1/processsingle', data)
    return riz
  }

  async getPdfDataByKey (key) {
    let riz = await api.get(`/v1/pdfbykey?key=${key}`)
    return riz.data
  }

  async getContacts (query) {
    let riz = await api.get(`/v1/postgres/contacts${query}`)
    return riz.data
  }

  async updateContact (contact) {
    let riz = await api.putAdmin('/v1/postgres/contacts/update', contact)
    console.log(riz.data)
    return riz.data
  }

  async getCsv (query) {
    try {
      const response = await api.get(`/v1/postgres/contacts/export${query}`, {
        headers: {
          'Accept': 'text/csv'
        },
        responseType: 'blob'
      })

      // Create a blob from the response
      const blob = new Blob([response.data], { type: 'text/csv' })

      // Create a download link and trigger it
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `contacts_export_${Date.now()}.csv`)
      document.body.appendChild(link)
      link.click()

      // Cleanup
      link.remove()
      window.URL.revokeObjectURL(url)

      return true
    } catch (error) {
      console.error('CSV download error:', error)
      return false
    }
  }

  async uploadPdfForOcr (file) {
    try {
      const formData = new FormData()
      formData.append('pdf', file)
      /* hybrid form post */
      //const response = await api.post('/v1/emnrd/upload-and-process',
      //const response = await api.post('/v1/emnrd/upload-and-process-hybrid',
      const response = await api.post('/v1/ocr/upload-and-process-vision',
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
      if(response != 500) {
        return response.data
      } else {
        return false
      }
    } catch (error) {
      console.error('PDF upload error:', error)
      return error
    }
  }

  async uploadPdfForCtb (file) {
    try {
      const formData = new FormData()
      formData.append('pdf', file)
      /* hybrid form post */
      //const response = await api.post('/v1/emnrd/upload-and-process',
      //const response = await api.post('/v1/emnrd/upload-and-process-hybrid',
      const response = await api.post('/v1/ocd-cbt/upload-and-process-vision',
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
      if(response != 500) {
        return response.data
      } else {
        return false
      }
    } catch (error) {
      console.error('PDF upload error:', error)
      return error
    }
  }

  async uploadPdfForOlm (file) {
    try {
      const formData = new FormData()
      formData.append('pdf', file)
      /* hybrid form post */
      const response = await api.post('/v1/olm/upload-and-process-vision',
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
      if(response != 500) {
        return response.data
      } else {
        return false
      }
    } catch (error) {
      console.error('PDF upload error:', error)
      return error
    }
  }

  async uploadPdfForPlc (file) {
    try {
      const formData = new FormData()
      formData.append('pdf', file)
      /* hybrid form post */
      const response = await api.post('/v1/plc/upload-and-process-vision',
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      })
      if(response != 500) {
        return response.data
      } else {
        return false
      }
    } catch (error) {
      console.error('PDF upload error:', error)
      return error
    }
  }

  async handleDupes (bool) {
    try {
      const riz = await api.postAdmin(`/v1/postgres/contacts/deduplicate?mode=name-only&dryRun=${bool}`)
      return riz
    } catch {
      return false
    }
  }

  async deleteContact (id) {
    try {
      const riz = await api.deleteAdminById(`/v1/postgres/contacts/${id}`)
      return riz
    } catch {
      return false
    }
  }

  async deleteContacts (data) {
    /* 
      expects the following object
      {
        "ids": [123, 456, 789]
      }

    */
    try {
      const riz = await api.postAdmin('/v1/postgres/contacts/bulk-delete', data)
      return riz
    } catch {
      return false
    }
  }

  async createPrompt () {
    try {
      console.log('not empty')
    } catch {
      return false
    }
  }

  async getPrompts () {
    try {
      const riz = await api.getAdmin('v1/extraction-prompts')
      return riz.data
    } catch {
      return false
    }
  }

  async getPrompt (_prompt) {
    try {
      const riz = await api.getAdmin(`/v1/extraction-prompts/${_prompt}`)
      return riz.data.prompt
    } catch {
      return false
    } 
  }

  async updatePrompt () {
    try {
      console.log('not empty')
    } catch {
      return false
    }
  }

  async getContactsReady (query) {
    // http://localhost:5151/v1/postgres/contactsready?limit=25&verified=true
    let riz = await api.get(`/v1/postgres/contactsready${query}`)
    return riz.data
  }

  async getContactsReadyStats () {
    let riz = await api.get('/v1/postgres/contactsready/stats')
    return riz
  }

  async getContactsStats () {
    let riz = await api.get('/v1/postgres/contacts/stats')
    return riz
  }

  async getContactsRaw () {
    try {
      console.log('raw contacts')
    } catch {
      return false
    }
  }

  async lastJobRun () {
    let riz = await api.get('/v1/job-runs?limit=1')
    return riz.data
  }

  async getJobsRun () {
    let riz = await api.get('/v1/job-runs')
    return riz
  }

  async getJobIds () {
    let riz = await api.get('/v1/postgres/contacts/jobids')
    return riz.data
  }
}

export default new DataServices()